<template>
  <div>
    <h1>Custom Model</h1>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "SEO Test | Custom Models",
      meta: [
        {
          vmid: "description",
          name: "description",
          content: "이 페이지는 babylonejs의 Custom Model 연습입니다.",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
